import type {SerializedStyles} from '@emotion/react';

import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  isFocused: boolean;
  isSelected: boolean;
  children: React.ReactNode;
  isDisabled: boolean;
};

const colorVariant = (
  // @ts-expect-error TS(7006) FIXME: Parameter 'isSelected' implicitly has an 'any' typ... Remove this comment to see the full error message
  isSelected,
  // @ts-expect-error TS(7006) FIXME: Parameter 'isDisabled' implicitly has an 'any' typ... Remove this comment to see the full error message
  isDisabled,
  // @ts-expect-error TS(7006) FIXME: Parameter 'theme' implicitly has an 'any' type.
  theme
): null | undefined | SerializedStyles => {
  if (isSelected) {
    return css`
      color: ${theme.colors.interactionSecondary};
    `;
  }

  if (isDisabled) {
    return css`
      color: ${theme.colors.contentTertiary};
    `;
  }

  return css`
    color: ${theme.colors.contentPrimary};
  `;
};

const backgroundVariant = (
  // @ts-expect-error TS(7006) FIXME: Parameter 'isSelected' implicitly has an 'any' typ... Remove this comment to see the full error message
  isSelected,
  // @ts-expect-error TS(7006) FIXME: Parameter 'isFocused' implicitly has an 'any' type... Remove this comment to see the full error message
  isFocused,
  // @ts-expect-error TS(7006) FIXME: Parameter 'theme' implicitly has an 'any' type.
  theme
): null | undefined | SerializedStyles => {
  if (isSelected) {
    return css`
      background: ${theme.colors.backgroundStateSelected};
    `;
  }

  if (isFocused) {
    return css`
      background: ${theme.colors.backgroundStateHover};
    `;
  }

  return css`
    background: transparent;
  `;
};

export const Option = styled.div<Props>(
  ({theme, isFocused, isSelected, isDisabled}) => css`
    padding: 12px 16px;

    ${isSelected
      ? theme.typography.labelMediumBold
      : theme.typography.labelMedium}

    ${colorVariant(isSelected, isDisabled, theme)}
    ${backgroundVariant(isSelected, isFocused, theme)}

    ${!isDisabled &&
    css`
      &:active {
        color: ${theme.colors.contentInversePrimary};
        background-color: ${theme.colors.interactionSecondary};
      }
    `}
    &:first-of-type {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }

    &:last-of-type {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  `
);
